import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ShieldCheck } from "lucide-react";
import { API } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const denied = location.state?.denied;

  useEffect(() => {
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => navigate("/admin", { state: { user: res.data }, replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0B2319] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="card-gold max-w-md w-full p-8 sm:p-10 text-center">
        <div className="w-14 h-14 rounded-full border border-[#D4AF37]/60 bg-[#0B2319] mx-auto flex items-center justify-center">
          <span className="font-serif font-bold text-[#D4AF37] tracking-widest">SC</span>
        </div>
        <h1 className="font-serif text-2xl sm:text-3xl font-bold text-[#0B2319] mt-5">
          Agent Portal
        </h1>
        <p className="text-sm text-[#5A6B63] mt-2">
          Sign in to view and manage quote requests.
        </p>
        {denied && (
          <p className="text-xs text-red-700 mt-4" data-testid="access-denied-message">
            Access is restricted to the agency owner account.
          </p>
        )}
        <button onClick={login} disabled={checking} data-testid="google-login-button"
                className="mt-7 w-full h-13 py-3.5 rounded-xl bg-[#0B2319] hover:bg-[#081A13] text-[#FCF6BA] font-semibold text-sm border border-[#D4AF37]/40 inline-flex items-center justify-center gap-2 transition-colors disabled:opacity-60">
          <ShieldCheck size={16} /> {checking ? "Checking session..." : "Sign in with Google"}
        </button>
        <Link to="/" data-testid="back-to-site-link"
              className="block mt-5 text-xs text-[#5A6B63] hover:text-[#0B2319] transition-colors">
          &larr; Back to simonnecofinancial quote page
        </Link>
      </div>
    </div>
  );
}
